import React from 'react';
import { cn } from '@/lib/utils';
import { Clock, AlertCircle, CheckCircle, XCircle } from 'lucide-react';

export const StatusBadge = ({ status, daysUntil }) => {
  const configs = {
    safe: {
      className: 'bg-green-500/10 text-green-500 border-green-500/20',
      icon: CheckCircle,
      label: `${daysUntil}d`,
      glow: 'shadow-[0_0_10px_rgba(16,185,129,0.3)]'
    },
    warning: {
      className: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
      icon: Clock,
      label: `${daysUntil}d`,
      glow: 'shadow-[0_0_10px_rgba(245,158,11,0.3)]'
    },
    critical: {
      className: 'bg-red-500/10 text-red-500 border-red-500/20',
      icon: AlertCircle,
      label: `${daysUntil}d`,
      glow: 'shadow-[0_0_10px_rgba(239,68,68,0.3)]'
    },
    expired: {
      className: 'bg-gray-500/10 text-gray-500 border-gray-500/20',
      icon: XCircle,
      label: 'Expired',
      glow: ''
    },
    unknown: {
      className: 'bg-gray-500/10 text-gray-500 border-gray-500/20',
      icon: Clock,
      label: 'Unknown',
      glow: ''
    }
  };

  const config = configs[status] || configs.unknown;
  const Icon = config.icon;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium font-mono border',
        config.className,
        config.glow
      )}
      data-testid={`status-badge-${status}`}
    >
      <Icon className="h-3 w-3" />
      {config.label}
    </span>
  );
};